<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :orgCode="editFormDialogOptions.code"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  activated() {
    this.getData(this.$refs.header.getForm())
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sampleStockSellListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
